import { v4 as uuid } from "uuid";
import type { Notification } from "src/contexts/_shared/domain/Notification";
import { NotificationStyles } from "src/contexts/_shared/domain/NotificationStyles";

export const createActorAccessNotification = (
  title: string,
  message: string,
  style: NotificationStyles,
): Notification => ({
  id: uuid(),
  title,
  message,
  messageParams: {},
  style,
  createdAt: new Date(),
});
